import { render, staticRenderFns } from "./Inubbm.vue?vue&type=template&id=79549a21&"
import script from "./Inubbm.vue?vue&type=script&lang=js&"
export * from "./Inubbm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports